import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import useMapStore from "@/store/mapStore";
import { motion } from "framer-motion";
import LanguageToggle from "./LanguageToggle";
import { Button } from "./ui/button";
import { PiXBold } from "react-icons/pi";
import Bookmark from "@/assets/bookmark-solid.svg";
// import Wifi from "@/assets/menu-wifi.svg";
// import CustomerServiceDesk from "@/assets/menu-customer-service-desk.svg";
import FindMyCar from "@/assets/menu-findmycar.svg";
import Offers from "@/assets/menu-offers.svg";
import Feedback from "@/assets/menu-feedback.svg";
import CityNav from "@/assets/menu-citynav.svg";
import {
  FilterCategoryModel,
  // FilterItemModel,
} from "@/models/filterItem.model";
// import { filterCategories } from "@/store/data";
// import useNavigateToAmenity from "@/hooks/useNavigateToAmenity";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

function MoreAccordion() {
  const mobileMode = useMapStore((state) => state.mobileMode);
  const ads = useMapStore((state) => state.ads);
  const kioskMode = useMapStore((state) => state.kioskMode);
  const activeCategory = useMapStore((state) => state.activeCategory);
  const verticalKioskMode = useMapStore((state) => state.verticalKioskMode);
  const setOverlayContent = useMapStore((state) => state.setOverlayContent);
  const setActiveMenuItem = useMapStore((state) => state.setActiveMenuItem);
  // const setActiveFilter = useMapStore((state) => state.setActiveFilter);
  const setActiveCategory = useMapStore((state) => state.setActiveCategory);

  const offersEnabled =
    import.meta.env.VITE_WAYFINDING_ENABLE_OFFERS === "true" && ads.length > 0;
  const findMyCarEnabled =
    import.meta.env.VITE_WAYFINDING_ENABLE_FIND_MY_CAR === "true";
  const feedbackEnabled =
    import.meta.env.VITE_WAYFINDING_COLLECT_FEEDBACK === "true";
  const showLanguageToggle = useRef<boolean>(
    import.meta.env.VITE_WAYFINDING_SHOW_LANGUAGE_TOGGLE === "true",
  );
  const cityNavEnabled =
    import.meta.env.VITE_WAYFINDING_ENABLE_CITYNAV === "true";
  const [value, setValue] = useState<string>(verticalKioskMode ? "" : "more");
  const isOpen = value === "more";

  // const [navigateToFacility] = useNavigateToAmenity();

  useEffect(() => {
    if (activeCategory?.id) {
      setValue(activeCategory.id);
    } else {
      setValue(verticalKioskMode ? "" : "more");
    }
  }, [activeCategory, verticalKioskMode]);

  useEffect(() => {
    // Extract URL query parameters
    const urlParams = new URLSearchParams(window.location.search);

    // if language is defined in urlParams hide lagnuage toggle for mobile mode
    if (urlParams.get("language") && mobileMode) {
      showLanguageToggle.current = false;
    }
  }, [mobileMode]);

  useEffect(() => {
    if (verticalKioskMode) {
      if (isOpen) {
        setActiveCategory({
          id: "more",
          title: "more",
          items: [],
        } as FilterCategoryModel);
      } else if (activeCategory?.id === "more") {
        setActiveCategory({} as FilterCategoryModel);
      }
    }
  }, [isOpen, verticalKioskMode, setActiveCategory]);

  /*const infoOpenHandler = (type: "wifi" | "share") => {
    if (type === "wifi") {
      const wifi = filterCategories[
        filterCategories.findIndex((i) => i.id === "facilities")
      ].items.find((i) => i.title === "wifi");
      if (wifi) {
        setActiveFilter(wifi as FilterItemModel);
      }
    }
    if (type === "share") {
      const share = filterCategories[
        filterCategories.findIndex((i) => i.id === "facilities")
      ].items.find((i) => i.title === "share");
      if (share) {
        setActiveFilter(share as FilterItemModel);
      }
    }
  };*/

  /*const serviceDeskOpenHandler = () => {
    navigateToFacility({ amenityTitle: "customer-service-desk" });
  };*/

  const accordionChangeHandler = (item: string) => {
    setValue(item);
  };

  if (mobileMode || verticalKioskMode) {
    return (
      <motion.div
        key="menu"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        transition={{ duration: 0.2 }}
        className={cn(
          "absolute top-[calc(100dvh-440px)] z-100 h-[440px] w-full rounded-t-2xl bg-white p-6 shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)] lg:top-[calc(100%-450px)]",
          verticalKioskMode &&
            "fixed bottom-14 left-[5%] top-auto z-100 h-[calc(28%-68px)] w-[90%] rounded-2xl lg:top-auto",
        )}
      >
        <h3 className="pb-4 text-xl font-bold">{t("more")}</h3>
        <Button
          size="icon"
          onClick={() => setActiveMenuItem("map")}
          className={cn(
            "absolute top-5 h-8 w-8 text-lg group-data-[dir=ltr]:right-5 group-data-[dir=rtl]:left-5",
          )}
        >
          <PiXBold />
        </Button>
        <ul className="space-y-2 pb-4 capitalize">
          {showLanguageToggle.current && (
            <li>
              <LanguageToggle />
            </li>
          )}
          {/*<li
            className={cn(
              "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
            )}
            onClick={serviceDeskOpenHandler}
          >
            <span className="block w-[24px]">
              <img
                src={CustomerServiceDesk}
                alt={t("customer-service-desk")}
                className="w-[24px]"
              />
            </span>
            {t("customer-service-desk")}
          </li>
          {verticalKioskMode && findMyCarEnabled && (
            <li
              className={cn(
                "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
              )}
              onClick={() => {
                setActiveMenuItem("map");
                setOverlayContent("findMyCar");
              }}
            >
              <span className="block w-[24px]">
                <img
                  src={FindMyCar}
                  alt={t("find-my-car")}
                  className="w-[24px]"
                />
              </span>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
                {t("find-my-car")}
              </p>
            </li>
          )}
          {mobileMode && cityNavEnabled && (
            <li
              className={cn(
                "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
              )}
              onClick={() => {
                setOverlayContent("cityNav");
                setActiveMenuItem("map");
              }}
            >
              <span className="block w-[24px]">
                <img
                  src={CityNav}
                  alt={t("navigate-to-from")}
                  className="w-[24px]"
                />
              </span>
              {t("navigate-to-from")}
            </li>
          )}
          {/*<li
            className={cn(
              "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
            )}
            onClick={() => {
              setActiveMenuItem("map");
              infoOpenHandler("wifi");
            }}
          >
            <span className="block w-[24px]">
              <img src={Wifi} alt={t("wifi")} className="w-[24px]" />
            </span>
            {t("wifi")}
          </li>*/}
          {offersEnabled && (
            <li
              className={cn(
                "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
              )}
              onClick={() => {
                setActiveMenuItem("map");
                setOverlayContent("offers");
              }}
            >
              <span className="block w-[24px]">
                <img src={Offers} alt={t("offers")} className="w-[24px]" />
              </span>
              {t("offers")}
            </li>
          )}
          {feedbackEnabled && (
            <li
              className={cn(
                "flex min-h-[32px] cursor-pointer items-center gap-3 hover:text-primary",
              )}
              onClick={() => {
                setActiveMenuItem("map");
                setOverlayContent("feedback");
              }}
            >
              <span className="block w-[24px]">
                <img
                  src={Feedback}
                  alt={t("send-us-feedback")}
                  className="w-[24px]"
                />
              </span>
              {t("send-us-feedback")}
            </li>
          )}
        </ul>
      </motion.div>
    );
  }

  const MoreContent = () => {
    return (
      <ul className="mb-2 flex flex-col gap-3 capitalize">
        {/*<li
          className={cn(
            "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
          )}
          onClick={serviceDeskOpenHandler}
        >
          <span className="block w-[24px]">
            <img
              src={CustomerServiceDesk}
              alt={t("customer-service-desk")}
              className="w-[24px]"
            />
          </span>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
            {t("customer-service-desk")}
          </p>
        </li>*/}
        {findMyCarEnabled && (
          <li
            className={cn(
              "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
            )}
            onClick={() => setOverlayContent("findMyCar")}
          >
            <span className="block w-[24px]">
              <img
                src={FindMyCar}
                alt={t("find-my-car")}
                className="w-[24px]"
              />
            </span>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
              {t("find-my-car")}
            </p>
          </li>
        )}
        {!kioskMode && cityNavEnabled && (
          <li
            className={cn(
              "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
            )}
            onClick={() => setOverlayContent("cityNav")}
          >
            <span className="block w-[24px]">
              <img
                src={CityNav}
                alt={t("navigate-to-from")}
                className="w-[24px]"
              />
            </span>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
              {t("navigate-to-from")}
            </p>
          </li>
        )}
        {/*kioskMode && (
          <li
            className={cn(
              "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
            )}
            onClick={() => infoOpenHandler("wifi")}
          >
            <span className="block w-[24px]">
              <img src={Wifi} alt={t("wifi")} className="w-[24px]" />
            </span>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
              {t("wifi")}
            </p>
          </li>
        )*/}
        {offersEnabled && (
          <li
            className={cn(
              "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
            )}
            onClick={() => setOverlayContent("offers")}
          >
            <span className="block w-[24px]">
              <img src={Offers} alt={t("offers")} className="w-[24px]" />
            </span>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
              {t("offers")}
            </p>
          </li>
        )}
        {kioskMode && feedbackEnabled && (
          <li
            className={cn(
              "group flex cursor-pointer items-center gap-3 rounded-md bg-gray-100 p-3 hover:bg-gray-200",
            )}
            onClick={() => setOverlayContent("feedback")}
          >
            <span className="block w-[24px]">
              <img
                src={Feedback}
                alt={t("send-us-feedback")}
                className="w-[24px]"
              />
            </span>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
              {t("send-us-feedback")}
            </p>
          </li>
        )}
      </ul>
    );
  };

  return (
    <>
      <Accordion
        type="single"
        collapsible
        value={value}
        onValueChange={accordionChangeHandler}
        className="w-full flex-1 kiosk:pointer-events-auto"
      >
        <AccordionItem
          value={"more"}
          className={cn("rounded-xl border-0 px-5 kiosk:w-full kiosk:p-0")}
        >
          <AccordionTrigger
            className={cn(
              "max-w-full justify-center text-2xl font-bold outline-none hover:text-foreground hover:no-underline kiosk:px-5",
              isOpen && "hover:text-foreground",
              activeCategory?.id
                ? "kiosk:justify-start"
                : "kiosk:justify-center",
              value && value !== "more" && "kiosk:opacity-30",
            )}
            // showToggle={isOpen}
            toggleClassName="kiosk:absolute kiosk:top-3.5 kiosk:group-data-[dir=ltr]:right-5 kiosk:group-data-[dir=rtl]:left-5"
          >
            <img
              src={Bookmark}
              alt=""
              className={cn(
                "w-[18px] group-data-[dir=ltr]:mr-3 group-data-[dir=rtl]:ml-3",
                !isOpen &&
                  "kiosk:group-data-[dir=ltr]:mr-0 kiosk:group-data-[dir=rtl]:ml-0",
              )}
            />
            <span
              className={cn(
                "group-data-[dir=ltr]:mr-auto group-data-[dir=rtl]:ml-auto kiosk:absolute kiosk:top-3.5 kiosk:px-7 kiosk:group-data-[dir=ltr]:left-10 kiosk:group-data-[dir=rtl]:right-10",
                !isOpen && "kiosk:hidden",
              )}
            >
              {t("more")}
            </span>
          </AccordionTrigger>
          <AccordionContent className="kiosk:pb-0">
            {verticalKioskMode && (
              <OverlayScrollbarsComponent
                className={cn(
                  "absolute left-10 top-16 z-10 max-h-[calc(100%-80px)] w-[calc(100%-60px)] overflow-auto px-5",
                )}
                options={{
                  scrollbars: { autoHide: "move", autoHideDelay: 3000 },
                  overflow: { x: "hidden" },
                }}
                defer
              >
                <MoreContent />
              </OverlayScrollbarsComponent>
            )}
            {!verticalKioskMode && <MoreContent />}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
}

export default MoreAccordion;
